import classNames from 'classnames';
import { FC } from 'react';

import { IcSCallIcon } from '@gem/icons';
import { DotLoader, IconView, IconViewSizes } from '@gem/ui-kit';

import { useJoinCallButtonPresenter } from './JoinCallButton.presenter';
import styles from './JoinCallButton.styles.m.css';

interface IJoinCallButtonProps {
  readonly className?: string;
  readonly hasActiveCall?: boolean;
  readonly startTs?: number;
  onClick?(): void;
}

export const JoinCallButton: FC<IJoinCallButtonProps> = ({
  className,
  hasActiveCall,
  startTs,
  onClick,
}) => {
  const { time } = useJoinCallButtonPresenter(startTs);

  return (
    <button
      className={classNames(styles.button, className, {
        [styles.canPress]: !hasActiveCall && !!onClick,
      })}
      type="button"
      disabled={hasActiveCall}
      onClick={onClick}
    >
      <IconView
        className={styles.icon}
        Icon={IcSCallIcon}
        size={IconViewSizes.Small}
      />
      {!startTs ? (
        <DotLoader itemClassName={classNames({ [styles.loaderActive]: hasActiveCall })} />
      ) : (
        <span className={styles.time}>{time}</span>
      )}
    </button>
  );
};
